module.exports = __webpack_public_path__ + "static/img/advantage2.6f54b3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tech/advantage2.png
// module id = A8K8
// module chunks = 11